

import Button from './Button';
import React from 'react';
import SecondaryButton from './SecondaryButton';
import { COLORS, NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { View } from 'react-native';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

interface TwoButtonsHorizontalProps {
    width?: number;
    onPressLeft: () => void;
    onPressRight: () => void;
    labelLeft: string;
    labelRight: string;
    smallText?: boolean;
    paddingVertical?:number;
  }

export const TwoButtonsHorizontal = ({ width: widthProp, paddingVertical, smallText, onPressLeft, onPressRight, labelLeft,labelRight}: TwoButtonsHorizontalProps) => {
  const {width} = useAvailableDimensions();
  const WIDTH= widthProp?widthProp:width;


  const PADDING_HORIZONTAL_MODAL = 25;
  const WIDTH_BUTTON = WIDTH - 2*PADDING_HORIZONTAL_MODAL;
  const SMALL_TEXT = smallText?smallText:false;
  const PADDING_VERTICAL = paddingVertical?paddingVertical:20;
  return (
    <View style={{ flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
      <View style={{marginHorizontal:0.05*WIDTH_BUTTON}}>
        <SecondaryButton
          width={WIDTH_BUTTON*0.4}
          color={COLORS.brand[500]}
          label={labelLeft}
          onPress={onPressLeft}
          paddingHorizontal={10}
          paddingVertical={PADDING_VERTICAL}
          marginHorizontal={0}
          smallText={SMALL_TEXT}
        />
      </View>
      <View style={{marginHorizontal:0.05*WIDTH_BUTTON}}>
        <Button
          width={WIDTH_BUTTON*0.4}
          label={labelRight}
          onPress={onPressRight}
          paddingHorizontal={10}
          paddingVertical={PADDING_VERTICAL}
          marginHorizontal={0}
          color={NEUTRAL_TEXT0}
          smallText={SMALL_TEXT}

        />
      </View>
    </View>
  );
};